import { Component, OnInit, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SideNavInnerToolbarModule } from '../side-nav-inner-toolbar/side-nav-inner-toolbar.component';
import { SideNavOuterToolbarModule } from '../side-nav-outer-toolbar/side-nav-outer-toolbar.component';
import { FooterModule } from '../../shared/components';

@Component({
  selector: 'app-dash-layout',
  templateUrl: './dash-layout.component.html',
  styleUrls: ['./dash-layout.component.scss']
})
export class DashLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}

@NgModule({
  imports: [RouterModule, CommonModule, SideNavInnerToolbarModule, SideNavOuterToolbarModule, FooterModule],
  exports: [DashLayoutComponent],
  declarations: [DashLayoutComponent]
})
export class DashLayoutModule { }